export const createOrderScreens = {
  'create': 'CreateOrderScreen',
  'main': 'MainScreen',
  'show': 'OrderDetailScreen',
  'parameters': 'ParametersScreen',
};
